import { useCallback, useState } from "react";

// Group open/closed state for the template tabs. Everything starts collapsed so a tab opens as a
// list of what is configured; the header summary is what makes that list worth reading.
export default function useExpandedGroups<T>(keys: T[]) {
    const [expanded, setExpanded] = useState<T[]>([]);

    const isExpanded = useCallback((key: T) => expanded.includes(key), [expanded]);

    const toggle = useCallback((key: T) => {
        setExpanded(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);
    }, []);

    const expand = useCallback((key: T) => {
        setExpanded(prev => prev.includes(key) ? prev : [...prev, key]);
    }, []);

    const collapse = useCallback((key: T) => {
        setExpanded(prev => prev.filter(k => k !== key));
    }, []);

    const allExpanded = keys.length > 0 && keys.every(k => expanded.includes(k));

    const toggleAll = useCallback(() => {
        setExpanded(allExpanded ? [] : [...keys]);
    }, [allExpanded, keys]);

    return { isExpanded, toggle, expand, collapse, allExpanded, toggleAll };
}
